module.exports = __webpack_public_path__ + "static/media/font_medium.b630657e.woff2";